import * as React from "react";
import {
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Typography
} from "@one-thd/sui-atomic-components";
import { OtpLoadingView } from "../../../NewVerifyOtpModal/OtpModalViews";

const StencilWebAuthnModal = ({isOpen, closeModal, headerText, email, children, isLoading, flow}) => {

  const renderTitle = (flowMode, loading) => {
    if(flowMode==="WEBAUTHN" && loading) {
      return "Follow your device instructions...."
    } else if (flowMode==="OTP" && loading) {
      return "Verifying Your Identity"
    } else if (flowMode==="OTP" && !loading) {
      return headerText
    }
  }

  return (
      <Modal
        open={isOpen}
        onClose={closeModal}
      >
        <ModalHeader onClose={closeModal}>
          { renderTitle(flow, isLoading) }
        </ModalHeader>
        { isLoading ? (
            <div className='otp-loading-container'>
              <OtpLoadingView/>
            </div>
        ) : (
            <>
              <ModalBody>
                <Typography variant="body-base">
                  To enable Face or Fingerprint ID enter the verification code we emailed to  <strong className='sui-break-all'> {email} </strong>
                </Typography>

              </ModalBody>
              <ModalFooter position="end">
                { children }
              </ModalFooter>
            </>
        )}
    </Modal>
  )
}

export default StencilWebAuthnModal;